define('blocks/features/features',['require'],function (require) {
    (function () {
        var $slider = $('.features__list');
        var isMobile = !!navigator.userAgent.match(/iPhone|iPod|iPad|iOS|android/i);

        var $body = $('body');

        function viewCarousel() {
            if (window.matchMedia('(max-width: 1365px)').matches) {
                if (!$slider.is('.owl-loaded')) {
                    $slider.owlCarousel({
                        nav: false,
                        dots: false,
                        loop: true,
                        autoWidth: true,
                        responsiveClass: true,
                        margin: 0,
                        items: 1,
                        smartSpeed: 700,
                        autoplay: true,
                        autoplayTimeout: 3000,
                    });
                }
            } else {
                if ($slider.is('.owl-loaded')) {
                    $slider.trigger('destroy.owl.carousel');
                }
            }
        }

        viewCarousel();

        if (isMobile) {
            window.addEventListener('orientationchange', viewCarousel, false);
        } else {
            $(window).resize(viewCarousel);
        }
    })();
});

